import React from 'react';
import { Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useSubscriptionCheck from '../../common/SubscriptionCheck';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { usePermissions } from '../../../hooks/usePermissions';
import { CREATE_SUPPLIER } from '../../../constants/eInvoicePermissions';
import { useAccessDeniedMessage } from '../../../hooks/useAccessDeniedMessage';
import PermissionDeniedWrapper from '../../../components/PermissionDeniedWrapper';
import BulkUploadButton from '../../bulkUpload/components/BulkUploadButton';

function SupplierListPageActions() {
  const navigate = useNavigate();
  const { checkSubscription, SubscriptionModal } = useSubscriptionCheck();
  const { hasEInvoicePermission } = usePermissions();
  const accessDeniedMessage = useAccessDeniedMessage();
  const { suppliers: s } = useTranslatedMessages();
  const canCreate = hasEInvoicePermission(CREATE_SUPPLIER);

  const handleCreateAction = () => {
    if (!canCreate || !checkSubscription()) {
      return;
    }
    navigate('/suppliers/create');
  };

  return (
    <>
      <Stack direction="row" spacing={1}>
        <BulkUploadButton category="SUPPLIER" requiredPermission={CREATE_SUPPLIER} redirectAfterSubmit="/bulk-upload" />
        <PermissionDeniedWrapper show={!canCreate} title={accessDeniedMessage}>
          <Button
            id="create-supplier"
            key="add-new-Supplier"
            variant="contained"
            color="primary"
            onClick={handleCreateAction}
            disabled={!canCreate}
          >
            {s?.list_actions?.add_new || '+ Create New Supplier'}
          </Button>
        </PermissionDeniedWrapper>
      </Stack>
      <SubscriptionModal />
    </>
  );
}

export default SupplierListPageActions;
